import type { ProductCardReviewSummaryProps } from '@maestro/commerce-blocks/components/product-card/product-card.types'

import Stars from '@maestro/commerce-blocks/components/reviews/stars'
import StarsSkeleton from '@maestro/commerce-blocks/components/reviews/stars-skeleton'

export default function ProductCardReviewSummary(
  props: ProductCardReviewSummaryProps
) {
  const { isLoading, reviewSummary } = props

  const hasReviewSummary = reviewSummary && reviewSummary.votes > 0

  return (
    <div className="product-card__review">
      {isLoading && <StarsSkeleton />}
      {!isLoading && hasReviewSummary && (
        <Stars rating={reviewSummary.decimalRating} />
      )}
    </div>
  )
}
